import { useTranslation } from 'react-i18next'
import { cn } from '../../utils/cn'

interface Step {
  isCompleted: boolean
  isActive: boolean
  label: string
}

interface Props {
  stepsConfig: Step[]
}

const PaymentStepNumbers = ({ stepsConfig }: Props) => {
  return (
    <div className='flex sm:items-center sm:justify-center gap-5 sm:gap-[70px] pb-5 sm:pb-[35px] flex-col sm:flex-row'>
      {stepsConfig.map((step, index) => (
        <PaymentStepNumber
          key={step.label}
          step={index + 1}
          isCompleted={step.isCompleted}
          isActive={step.isActive}
          label={step.label}
        />
      ))}
    </div>
  )
}

export default PaymentStepNumbers

function PaymentStepNumber({
  step,
  isCompleted = false,
  isActive = false,
  label,
}: {
  step: number
  isCompleted?: boolean
  isActive?: boolean
  label: string
}) {
  const { t } = useTranslation()

  return (
    <div className='flex items-center gap-2.5'>
      <div
        className={cn(
          'rounded-full flex items-center justify-center w-11 h-11 min-w-11 min-h-11',
          isCompleted && 'bg-[#E1ECFC] text-white',
          isActive && 'bg-primaryBlue text-white',
          // Steps still ahead of the user stay muted rather than reading as
          // active alongside the current one.
          !isCompleted && !isActive && 'bg-[#E9E9E9] text-[#3E3E3E]',
        )}
      >
        <p>
          {isCompleted ? (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='15'
              height='11'
              viewBox='0 0 15 11'
              fill='none'
            >
              <path
                d='M13 1.71875L5.4375 9.28125L2 5.84375'
                stroke='white'
                strokeWidth='2.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          ) : (
            step
          )}
        </p>
      </div>
      <p
        className={cn(
          'text-sm',
          isCompleted ? 'text-[#ABABAB]' : 'text-[#3E3E3E]',
          isActive && 'font-semibold',
        )}
      >
        {t(label)}
      </p>
    </div>
  )
}
